import React from 'react';

import { SelectField, TextAreaField, TextField } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';
import { objectToSelectList } from 'src/helpers';
import model from './model';
import NavigationButtons from './NavigationButtons';
import LANG_CONST from 'src/helpers/lang/const';
import { FormRow } from 'src/components/Form';

export default class SpecialityStep extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  render() {
    const { handleChangeProfile } = model;
    const { error, errorMessage, invalid, loading } = model.getApiState('updateSpecialist');

    return (
      <>
        <div
          className='mc-modal-body'
          style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}
        >
          {!!error && <p className='mc-error'>{errorMessage}</p>}
          <div className='mc-form mc-flex-col-20'>
            <FormRow>
              <SelectField
                template={6}
                width={'100%'}
                placeholder={'Enter keyword here'}
                label={LANG_CONST.speciality}
                isMultipleSpecial={true}
                isClearable={false}
                options={objectToSelectList(LANG_CONST.constants.specialist, true)}
                name={'specialist'}
                description={LANG_CONST.text.speciality_des}
                value={model.input('specialist')}
                onChange={handleChangeProfile}
                invalid={invalid}
              />
            </FormRow>
            <FormRow>
              <TextField
                template={6}
                label={LANG_CONST.sub_speciality}
                name={'subSpeciality'}
                placeholder={''}
                value={model.input('subSpeciality')}
                onChange={handleChangeProfile}
                invalid={invalid}
              />
            </FormRow>
            <FormRow>
              <TextAreaField
                template={6}
                rows={4}
                name={'description'}
                label={'Description'}
                placeholder={''}
                value={model.input('description')}
                onChange={handleChangeProfile}
                invalid={invalid}
              />
            </FormRow>
          </div>
        </div>
        <NavigationButtons
          hide={this.props.close}
          next={() => model.saveSpeciality((err) => !err && this.props.next())}
          loading={loading}
        />
      </>
    );
  }
}
